import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import TopLevelTag from '../common/TopLevelTag.vue'
var topImg = {
  0: 'https://p0.pipi.cn/rock/prod/common/image/8052dcec9f31291e9722472ea26de9a5.png?imageMogr2/thumbnail/2500x2500%3E',
  1: 'https://p0.pipi.cn/rock/prod/common/image/39d5df43ee417b891a81f1dcb3ccc4f4.png?imageMogr2/thumbnail/2500x2500%3E',
  2: 'https://p0.pipi.cn/rock/prod/common/image/1aea69d74fe3e00b07d9e390b824b371.png?imageMogr2/thumbnail/2500x2500%3E'
};
import { parseDetailUrl } from "@/utils";
export default {
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    return {
      topImg: topImg
    };
  },
  components: {
    // TopLevelTag,
  },
  mounted: function mounted() {
    var scrollEl = document.getElementById('top-scroll-view-stats');
    scrollEl.addEventListener('scroll', window.StatusReportData, false);
  },
  methods: {
    goToTopList: function goToTopList() {
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_394nf0f8_mc',
        cid: 'c_movie_aq5xt2v5',
        needTag: true
      });
      this.go("/topList", {
        _blank: true
      });
    },
    goToTop: function goToTop(id) {
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_eg318qa6_mc',
        cid: 'c_movie_aq5xt2v5',
        billboard_id: id,
        needTag: true
      });
      this.go("/top/".concat(id, "?type=1"), {
        _blank: true
      });
    },
    handleClick: function handleClick(project) {
      var _ref = project || {},
        performanceId = _ref.performanceId,
        dataSeed = _ref.dataSeed,
        _ref$jumpDetailUrl = _ref.jumpDetailUrl,
        jumpDetailUrl = _ref$jumpDetailUrl === void 0 ? '' : _ref$jumpDetailUrl;
      if (!performanceId) return;
      if (dataSeed) {
        window.seedAction(Object.assign({}, project.dataSeed, {
          needTag: true
        }));
      }
      if (jumpDetailUrl) {
        this.go(parseDetailUrl(jumpDetailUrl), {
          _blank: true
        });
      } else {
        this.go("/detail/".concat(performanceId), {
          _blank: true
        });
      }
      // this.go(`/detail/${performanceId}`, { _blank: true })
    },

    showPriceSuffix: function showPriceSuffix(priceRange) {
      if (priceRange === '价格待定') {
        return false;
      } else if (priceRange && priceRange.split('-').length > 1) {
        return true;
      } else {
        return false;
      }
    }
  }
};